import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { createImageUrl } from '../../../../../../../helper/Converters';

const ProductDetail_2 = ({ item }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);

  const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
  const firstProduct = selectedProduct?.data;
  const image = createImageUrl(firstProduct?.variants?.[0]?.images?.[0]?.id);
  const [hashMap, setHashMap] = useState({});
  const productVariantTypes = firstProduct?.productVariantTypes;
  const firsVariantHash = productVariantTypes
    ?.map(variantType => {
      const variantTypeId = variantType?.variantType?.id;
      const variantValueIds = variantType?.variantValueIds;
      return variantTypeId + variantValueIds?.[0];
    })
    ?.join(';');
  const iscolorVariant_Exists = productVariantTypes?.find(type => type?.variantType?.selectionType === 'COLOR');
  const istextVariant_Exists = productVariantTypes?.find(type => type?.variantType?.selectionType === 'CHOICE');
  console.log(iscolorVariant_Exists);
  useEffect(() => {
    const variantTypeValueArray = firstProduct?.productVariantTypes?.map(variantType => {
      const variantTypeId = variantType?.variantType?.id;
      const variantValueIds = variantType?.variantValueIds;
      return { variantTypeId, variantValueIds };
    });

    const objectMap = {};
    firstProduct?.variants?.map(variant => {
      const keyArr = [];
      const variantValues = variant?.variantValues;
      variantValues?.map(v => {
        const variantTypeId = v?.variantTypeId;
        const variantValueId = v?.variantValueId;
        const typeIndex = variantTypeValueArray?.findIndex(
          variantTypeValue => variantTypeValue?.variantTypeId === variantTypeId,
        );
        if (typeIndex !== -1) {
          keyArr[typeIndex] = variantTypeId + variantValueId;
        }
      });
      const key = keyArr?.join(';');
      objectMap[key] = variant;
    });
    setHashMap(objectMap);
  }, []);

  return (
    <div className="p-3">
      <div className="border-1 border-[#EAEBED] rounded-[5px]">
        <img
          className="rounded-[5px]"
          width={'100%'}
          style={{ aspectRatio: 1, objectFit: 'cover' }}
          src={image || process.env.REACT_APP_DEFAULT_IMAGE}
          alt=""
        />
      </div>
      <div
        className=" "
        style={{
          paddingTop: staticValues[10],
          paddingBottom: staticValues[10],
          display: 'flex',
          gap: staticValues[10],
          overflow: 'hidden',
          borderRadius: 5,
        }}
      >
        {firstProduct?.variants?.[0]?.images?.map((image, index) => (
          <img
            className="border-1 border-[#EAEBED] "
            src={createImageUrl(image?.id)}
            style={{ aspectRatio: 1, width: staticValues[55], objectFit: 'cover', borderRadius: 5 }}
          />
        ))}
      </div>
      <div
        className="py-2 px-4 border-1 border-[#EAEBED] rounded-[5px]"
        style={{
          marginBottom: staticValues[10],
          backgroundColor: '#FFFFFF',
        }}
      >
        <div>
          {
            <div
              className="flex flex-row justify-between align-center "
              style={{
                fontSize: staticValues[12],
                color: '#80716B',
                fontStyle: 'normal',
                fontWeight: 600,
                paddingTop: staticValues[10],
              }}
            >
              {firstProduct?.brand?.name || 'Ürün Markası'}
            </div>
          }
          <div className={`${'flex flex-row justify-between align-center'}`}>
            <div
              style={{
                textAlign: 'left',
                fontSize: staticValues[16],
                color: '#382E2A',
                fontStyle: 'normal',
                fontWeight: 500,
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: firstProduct?.name || 'Ürün Başlığı' }}></div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
              <img
                width={staticValues[16]}
                height={staticValues[16]}
                src={
                  'https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710503763_1efbc907-9cef-4092-a303-d8f858f20851.png'
                }
              />
            </div>
          </div>
          <div
            style={{
              textAlign: 'left',
              fontSize: staticValues[12],
              color: '#000000',
              fontStyle: 'normal',
            }}
          >
            {firstProduct?.name || 'Ürün Başlığı'}
          </div>
          <div
            style={{
              color: '#FF863D',
              fontSize: staticValues[14],
              paddingBottom: staticValues[5],
              paddingTop: staticValues[5],
              textAlign: 'left',
            }}
          >
            {firstProduct?.variants?.[0]?.prices?.[0]?.currencySymbol}
            {firstProduct?.variants?.[0]?.prices?.[0]?.sellPrice?.toFixed(2)}
          </div>
          {/* <div
            style={{
              textAlign: 'left',
              fontSize: staticValues[12],
              fontWeight: 500,
            }}
          >
            {'Test Cross'}
          </div>
          <div
            style={{
              textAlign: 'left',
              fontSize: staticValues[10],
            }}
          >
            {'Test Cross'}
          </div> */}
          <div
            style={{
              marginTop: staticValues[10],
              paddingBottom: staticValues[20],
            }}
          >
            {/* <div
              style={{
                display: 'flex',
                gap: 10,
                marginBottom: staticValues[10],
              }}
            >
              <div>
                <div
                  style={{
                    border: '1px solid #E6E7EB',
                    borderRadius: 5,
                    width: staticValues[14],
                    height: staticValues[14],
                  }}
                ></div>
              </div>
              <div>
                {
                  <img
                    className="border-1 border-[#EAEBED] "
                    src={createImageUrl(secondProduct?.variants?.[0]?.images?.[0]?.id)}
                    style={{ aspectRatio: 1, width: staticValues[70], objectFit: 'cover', borderRadius: 5 }}
                  />
                }
              </div>
              <div>
                <div
                  style={{
                    fontSize: staticValues[12],
                    fontWeight: 500,
                    textAlign: 'left',
                  }}
                >
                  {secondProduct?.name}
                </div>
                <div style={{ display: 'flex', textAlign: 'left', gap: 5 }}>
                  <div
                    style={{
                      fontSize: staticValues[12],
                      color: '#BAB9B9',
                      textDecoration: 'line-through',
                    }}
                  >
                    {secondProduct?.variants?.[0]?.prices?.[0]?.currencySymbol}
                    {secondProduct?.variants?.[0]?.prices?.[0]?.sellPrice?.toFixed(2)}
                  </div>
                  <div
                    style={{
                      fontSize: staticValues[12],
                      color: '#FF863D',
                      fontWeight: 600,
                    }}
                  >
                    {secondProduct?.variants?.[0]?.prices?.[0]?.currencySymbol}
                    {secondProduct?.variants?.[0]?.prices?.[0]?.discountPrice?.toFixed(2)}
                  </div>
                </div>
              </div>
            </div> */}
            <div
              style={{
                display: 'flex',
                gap: 10,
              }}
            >
              <div
                className="px-4"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  backgroundColor: '#F6F6F6',
                  width: '35%',
                  borderRadius: 5,
                }}
              >
                <div
                  style={{
                    color: '#A1A1A1',
                  }}
                >
                  -
                </div>
                <div>1</div>
                <div>+</div>
              </div>
              <div
                style={{
                  flex: 1,
                  padding: staticValues[5],
                  backgroundColor: '#FE873E',
                  color: 'white',
                  borderRadius: 5,
                }}
              >
                Sepete Ekle
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="py-2 px-4 border-1 border-[#EAEBED] rounded-[5px]"
        style={{
          backgroundColor: '#FFFFFF',
        }}
      >
        <div className="w-full">
          <div
            className="border-b"
            style={{
              display: 'flex',
              justifyContent: 'center',
              borderBottomColor: '#FE873E',
            }}
          >
            <button
              className={`p-2 px-4 
         text-[#FE873E]
            `}
            >
              Ürün Detayı
            </button>
          </div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                textAlign: 'left',
                gap: 5,
              }}
              className="py-2.5 "
            >
              {
                <div
                  style={{
                    fontSize: staticValues[14],
                    fontWeight: 400,
                    color: '#000000',
                    fontStyle: 'normal',
                    marginBottom: 10,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <div
                    style={{ width: '100%', textAlign: 'left' }}
                    dangerouslySetInnerHTML={{ __html: firstProduct?.description }}
                  ></div>
                </div>
              }

              <div dangerouslySetInnerHTML={{ __html: firstProduct?.description }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail_2;
